/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q5_AnswerInputs */

const en_faq_q5_answer = /** @type {(inputs: Faq_Q5_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`“Eligibility” refers to a list of requirements that must be met in order for you to qualify for insurance. If eligibility requirements are not met, your medical expenses will not be covered by insurance. This list is fully outlined in the Eligibility section of your policy.`)
};

const fr_faq_q5_answer = /** @type {(inputs: Faq_Q5_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'« admissibilité » désigne une liste de conditions qui doivent être remplies pour que vous puissiez bénéficier d'une assurance. Si les conditions d'admissibilité ne sont pas remplies, vos frais médicaux ne seront pas couverts par l'assurance. Cette liste est entièrement décrite dans la section Admissibilité de votre police.`)
};

/**
* | output |
* | --- |
* | "“Eligibility” refers to a list of requirements that must be met in order for you to qualify for insurance. If eligibility requirements are not met, your medi..." |
*
* @param {Faq_Q5_AnswerInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const faq_q5_answer = /** @type {((inputs?: Faq_Q5_AnswerInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q5_AnswerInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_q5_answer(inputs)
	return fr_faq_q5_answer(inputs)
});